import Recipients from '../store/schema/Recipients';
import { Envelope, Recipient } from '@qas/smartcompose-tslibrary/dist/src/session';
import {
    Envelope as LegacyEnvelope,
    Recipient as LegacyRecipient,
} from 'smartcompose-tslibrary-old/dist/session';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export default function createEnvelope(
    subject: string,
    recipients: Recipients,
    user: Recipient,
    constraints: Map<string, string>
): Envelope {
    return {
        subject: subject,
        to: recipients.toRecipients.map(recipient =>
            transformEmailAddressWrapperToRecipient(recipient)
        ),
        user: user,
        dateTime: new Date(Date.now()),
        constraints: constraints,
    };
}

export function createLegacyEnvelope(subject: string, recipients: Recipients): LegacyEnvelope {
    return {
        subject: subject,
        to: recipients.toRecipients.map(recipient =>
            transformEmailAddressWrapperToLegacyRecipient(recipient)
        ),
        cc: recipients.ccRecipients.map(recipient =>
            transformEmailAddressWrapperToLegacyRecipient(recipient)
        ),
        bcc: recipients.bccRecipients.map(recipient =>
            transformEmailAddressWrapperToLegacyRecipient(recipient)
        ),
        attached: [],
    };
}

export function transformEmailAddressWrapperToRecipient(
    emailAddressWrapper: EmailAddressWrapper
): Recipient {
    return new Recipient(
        emailAddressWrapper.EmailAddress,
        emailAddressWrapper.Name,
        emailAddressWrapper.MailboxType
    );
}

export function transformEmailAddressWrapperToLegacyRecipient(
    emailAddressWrapper: EmailAddressWrapper
): LegacyRecipient {
    return new LegacyRecipient(
        emailAddressWrapper.EmailAddress,
        emailAddressWrapper.Name,
        emailAddressWrapper.MailboxType
    );
}
